import { render } from "./IconReorder.vue?vue&type=template&id=6c5c03e4"
import script from "./IconReorder.vue?vue&type=script&lang=js"
export * from "./IconReorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__